"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.encephalopathyGradeMessages = exports.hasOccurredMessages = exports.EncephalopathyGrade = exports.HasOccurred = void 0;
const schema_1 = require("../../../../../schema");
var HasOccurred;
(function (HasOccurred) {
    HasOccurred["OCCURRED"] = "OCCURRED";
    HasOccurred["NOT_OCCURRED"] = "NOT_OCCURRED";
})(HasOccurred || (exports.HasOccurred = HasOccurred = {}));
var EncephalopathyGrade;
(function (EncephalopathyGrade) {
    EncephalopathyGrade["GRADE_0"] = "GRADE_0";
    EncephalopathyGrade["GRADE_I"] = "GRADE_I";
    EncephalopathyGrade["GRADE_II"] = "GRADE_II";
    EncephalopathyGrade["GRADE_III"] = "GRADE_III";
    EncephalopathyGrade["GRADE_IV"] = "GRADE_IV";
})(EncephalopathyGrade || (exports.EncephalopathyGrade = EncephalopathyGrade = {}));
exports.hasOccurredMessages = {
    [HasOccurred.OCCURRED]: {
        id: "ltx.phaseI.medicalHistory.liverRelatedComplications.encephalopathy.hasOccurred.OCCURRED",
        defaultMessage: "Igen"
    },
    [HasOccurred.NOT_OCCURRED]: {
        id: "ltx.phaseI.medicalHistory.liverRelatedComplications.encephalopathy.hasOccurred.NOT_OCCURRED",
        defaultMessage: "Nem"
    }
};
exports.encephalopathyGradeMessages = {
    [EncephalopathyGrade.GRADE_0]: {
        id: "ltx.phaseI.medicalHistory.liverRelatedComplications.encephalopathy.encephalopathyGrade.GRADE_0",
        defaultMessage: "Nincs"
    },
    [EncephalopathyGrade.GRADE_I]: {
        id: "ltx.phaseI.medicalHistory.liverRelatedComplications.encephalopathy.encephalopathyGrade.GRADE_I",
        defaultMessage: "Grade I"
    },
    [EncephalopathyGrade.GRADE_II]: {
        id: "ltx.phaseI.medicalHistory.liverRelatedComplications.encephalopathy.encephalopathyGrade.GRADE_II",
        defaultMessage: "Grade II"
    },
    [EncephalopathyGrade.GRADE_III]: {
        id: "ltx.phaseI.medicalHistory.liverRelatedComplications.encephalopathy.encephalopathyGrade.GRADE_III",
        defaultMessage: "Grade III"
    },
    [EncephalopathyGrade.GRADE_IV]: {
        id: "ltx.phaseI.medicalHistory.liverRelatedComplications.encephalopathy.encephalopathyGrade.GRADE_IV",
        defaultMessage: "Grade IV"
    }
};
const hasOccurred = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(HasOccurred.OCCURRED),
    schema_1.Schema.singleChoiceItem(HasOccurred.NOT_OCCURRED)
]).interpretation({ vocab: "ltx", code: "encephalopathy" });
const encephalopathyGrade = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../hasOccurred} === "OCCURRED"`), schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(EncephalopathyGrade.GRADE_0),
    schema_1.Schema.singleChoiceItem(EncephalopathyGrade.GRADE_I),
    schema_1.Schema.singleChoiceItem(EncephalopathyGrade.GRADE_II),
    schema_1.Schema.singleChoiceItem(EncephalopathyGrade.GRADE_III),
    schema_1.Schema.singleChoiceItem(EncephalopathyGrade.GRADE_IV)
]).interpretation({ vocab: "ltx", code: "encephalopathy_grade" }));
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ hasOccurred, encephalopathyGrade });
